@if (loading()) {
  <div class="main-loading-window">
    <img class="scale-animation" src="/images/logos/logo.svg" alt="">
  </div>
} @else {
  <section class="overflow-hidden">
    <app-header/>

    <div class="router-section">
      <router-outlet/>
    </div>

    <app-footer></app-footer>

    <app-to-top-button></app-to-top-button>
    <app-message></app-message>
  </section>
}


